/**
 * Slanted
 */
import {breakpoint, containerID, assets_path} from '@/_constant/variables';
import 'es6-promise/auto';
import 'picturefill';
import {gsap, Quart, Elastic} from 'gsap';
import GAPlugin from '@/_modules/ga-plugin'
Vue.use(GAPlugin);

import Vue from 'vue';
import store from '@/_modules/stores';
import router from '@/_modules/router';
import GlobalHeader from '@/_components/global-header.vue';
import SpHeader from '@/_components/sp-header.vue';
import MainViewer from '@/_components/main-viewer.vue';

// gaページビュー実行
/*
router.afterEach((to, from) => {
  if (ga) ga('send', 'pageview', to.path);
});
*/

export default class AppVue {

  constructor() {
    // クラス名
    this.name = 'AppVue';
    this.init();
  }

  init() {
    const data = JSON.parse(document.getElementById('site-json').textContent);
    Vue.prototype.$siteData = data;

    this.vue = new Vue({
      components: {
        GlobalHeader,
        SpHeader,
        MainViewer
      },
      data() {
        return {
          breakpoint: breakpoint,
          assets_path: assets_path,
          toPage: '',
          fromPage: '',
          hideCallback: null,
          tl: null,
        }
      },
      el: containerID,
      router,
      store,
      watch: {
        '$route': function (to, from) {
          this.toPage = to.name;
          this.fromPage = from.name;
          this.createPageTitle(to);
        }
      },
      mounted() {
        this.resize();
        window.addEventListener('resize', this.resize);

        this.$nextTick(this.start);
      },
      methods: {
        init() {

        },
        createModal() {
          this.tl = gsap.timeline({paused: true});

          this.tl.addLabel('start', 0);

          this.tl.set(this.$refs['c-modalNews__wrap'].querySelector('.is-bg'), {
            scale: 1.4,
          }, 0);
          this.tl.set(this.$refs['c-modalNews__wrap'].querySelector('.is-bg2'), {
            scale: 1.4,
          }, 0);
          this.tl.set(this.$refs['c-modalNews__wrap'].querySelector('.is-title'), {
            opacity: 0,
            y: 40,
          }, 0);
          this.tl.set(this.$refs['c-modalNews__wrap'].querySelector('.is-text'), {
            opacity: 0,
            y: 40,
          }, 0);
          this.tl.set(this.$refs['c-modalNews__wrap'].querySelector('.is-close'), {
            scale: 0,
          }, 0);

          this.tl.to(this.$refs['c-modalNews__wrap'].querySelector('.is-bg'), {
            duration: 1.2,
            scale: 1.0,
            ease: Elastic.easeOut,
          }, 0);

          this.tl.to(this.$refs['c-modalNews__wrap'].querySelector('.is-bg2'), {
            duration: 1.2,
            scale: 1.0,
            ease: Elastic.easeOut,
          }, 0);

          this.tl.to(this.$refs['c-modalNews__wrap'].querySelector('.is-title'), {
            duration: 0.7,
            opacity: 1,
            y: 0,
            ease: Quart.easeOut,
          }, 0.4);

          this.tl.to(this.$refs['c-modalNews__wrap'].querySelector('.is-text'), {
            duration: 0.7,
            opacity: 1,
            y: 0,
            ease: Quart.easeOut,
          }, 0.4);

          this.tl.to(this.$refs['c-modalNews__wrap'].querySelector('.is-close'), {
            duration: 0.5,
            scale: 1,
            clearProps: 'all',
            ease: Quart.easeInOut,
          }, 0.6);

          this.tl.play('start');
        },
        start() {
          // container-viewerでローディングは消しています
        },
        createPageTitle(to) {
          if(to.name !== 'works') {
            document.title = to.meta.title;
            document.querySelector("meta[name='description']").setAttribute('content', to.meta.desc);
          }

          if(to.name === 'top') {
            document.querySelector("meta[property='og:type']").setAttribute('content', 'website');
          } else {
            document.querySelector("meta[property='og:type']").setAttribute('content', 'article');
          }
        },
        closeNews() {
          this.$store.commit('setOpenNews', false);
        },
        enterNews(el, done) {
          // console.log('enterNews');
          // アニメーション開始
          this.createModal();
          done();
        },
        leaveNews(el, done) {
          // console.log('leaveNews');
          // アニメーション停止
          this.tl.kill();
          this.tl = null;
          done();
        },
        resize() {
          if (window.innerWidth > breakpoint) {
            this.$store.commit('setPc', true);
          } else {
            this.$store.commit('setPc', false);
          }
        }
      }
    });
  }
}
